<template>
	<div v-if="forceRenderOnServer || isMounted" class="full-height">
		<slot />
	</div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue';

defineProps<{
	forceRenderOnServer: boolean;
}>();

const isMounted = ref(false);

onMounted(() => (isMounted.value = true));
</script>

<style scoped lang="scss">
.full-height {
	height: 100%;
}
</style>
